export const FACEBOOK_APP_ID = "241284008322";
